import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../common/components/Button';
import Checkbox from '../common/components/Checkbox';
import { DefaultButton } from '../common/components/DefaultButton';
import { Col, Container, Row } from '../common/components/Grid';
import { compareJobFilters } from '../reducers/jobFilterSlice';

import PropTypes from 'prop-types';
import Icon from '../common/components/Icon';
import { distinct } from '../common/utils/arrayUtilities';
import { Modal } from '../common/utils/dialogUtlities';

const processFilters = filters => filters.map(f => f.kind === 'Zone' ? { ...f, selected: !f.selected } : { ...f });

export const JobFilterModal = ({ filters: inputFilters, includeAssistance: inputIncludeAssistance = false, showModal, handleClose }) => {
    const { t } = useTranslation();
    const [includeAssistance, setIncludeAssistance] = useState(inputIncludeAssistance);
    const [filters, setFilters] = useState(processFilters(inputFilters));
    const kinds = useMemo(() => distinct(filters, 'kind').map(f => f.kind), [filters]);

    useEffect(() => {
        setFilters(processFilters(inputFilters));
    }, [inputFilters]);

    useEffect(() => {
        setIncludeAssistance(inputIncludeAssistance);
    }, [inputIncludeAssistance]);

    const toggleKind = kind => {
        const allSelected = filters.every(f => f.kind !== kind || f.selected);
        setFilters(filters.map(f => f.kind === kind ? { ...f, selected: !allSelected} : f));
    }
    
    const toggleFilter = f => setFilters(filters => filters.map(f2 => compareJobFilters(f, f2) ? { ...f2, selected: !f2.selected } : f2 ));

    const resetFilters = () => setFilters(filters => filters.map(f => ({ ...f, selected: f.kind === 'Zone' })));;

    return (
        <Modal show={showModal} onHide={() => handleClose()} size='xlg'>
            <Modal.Header closeButton>
                <Modal.Title>{t('jobFilterConfig')}</Modal.Title>
            </Modal.Header>
            { showModal ? <Modal.Body>
                <Container fluid>
                    <Row>
                        {kinds.map(kind => <Col key={kind + '_title'} style={{cursor: 'pointer'}} onClick={() => toggleKind(kind)}><span style={{fontWeight: 'bold'}}>{kind}</span> <Button className="my-0 ml-3 p-0" style={{border: 'none', fontSize: 'smaller'}} onClick={() => toggleKind(kind)} variant="link">{filters.filter(f => f.kind === kind).every(f => f.selected) ? t('selectAll') : t('clearAll')}</Button></Col>)}
                    </Row>
                    <Row>
                        {kinds.map(kind => <Col key={kind}>
                            {filters.filter(f => f.kind === kind).map(f => <Row key={f.kind + '_' + f.type}>
                                <Col>
                                    <Checkbox inline placeholder={f.type} checked={!f.selected} onChange={() => toggleFilter(f)}></Checkbox>
                                </Col>
                            </Row>)}
                        </Col>)}
                    </Row>
                    <Row className="mt-2 pt-2" style={{borderTop: '1px solid lightgrey', fontWeight: 'bold'}}>
                        <Col>{t('settings')}</Col>
                    </Row>
                    <Row>
                        <Col className="d-flex d-flex-row">
                            <Checkbox inline placeholder={t('includeAssistance')} checked={includeAssistance} onChange={() => setIncludeAssistance(!includeAssistance)}></Checkbox>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body> : <Modal.Body></Modal.Body>}
            <Modal.Footer>
                <Container fluid>
                    <Row>
                        <Col>
                            <Button variant="danger" onClick={resetFilters}>
                                <Icon variant="solid" kind="arrows-rotate"></Icon> {t('resetFilters')}
                            </Button>
                            <DefaultButton className="mx-2" kind="save" label={t('makeDefault')} onClick={() => handleClose({ filters, persist: true, includeAssistance})}></DefaultButton>
                        </Col>
                        <Col className="text-right">
                            <DefaultButton className="mx-2" kind="apply" onClick={() => handleClose({ filters, persist: false, includeAssistance })}></DefaultButton>
                            <DefaultButton kind="close" onClick={() => handleClose()}></DefaultButton>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
};

JobFilterModal.propTypes = {
    filters: PropTypes.array,
    persist: PropTypes.bool,
    includeAssistance: PropTypes.bool,
    showModal: PropTypes.bool,
    handleClose: PropTypes.func
}